import { GetRequest, PutRequest } from "../service"

const ControllerName = "Request" // This controller for provider registration request

export const GetMedicalRequest = (link) =>
    GetRequest(ControllerName + link)

export const GetMedicalRequestDetails = (id) =>
    GetRequest(`${ControllerName}/getDetails/${id}`)

export const CreateQuotation = (id, data) =>
    PutRequest(`${ControllerName}/createQuotation/${id}`, data)

export const GetAdmissionDetails = (id) =>
    GetRequest(`${ControllerName}/getAdmissionDetails/${id}`)

export const CreatePostService = (data) =>
    PutRequest(`${ControllerName}/createPostService`, data)

export const SubmitAdmission = (id) =>
    PutRequest(`${ControllerName}/startQuotation/${id}`)

export const DeclineQuotation = (id) =>
    PutRequest(`${ControllerName}/declinedQuotation/${id}`)

export const DischargeQuotation = (id) =>
    PutRequest(`${ControllerName}/dischargeQuotation/${id}`)
